export enum ContentMastheadType {
  HERO = 'hero',
  INSET = 'inset',
  TEXTONLY = 'textonly',
  USER = 'user',
}
